const clientUrl = 'https://www.catwalk-kratzbaeume.de/designer';
const remoteUrl = 'https://www.catwalk-kratzbaeume.de';

export default {
    api: {
        magento: remoteUrl + '/rest/V1',                                    // fallback for magento shop api (used e.g. to fetch products); only used if Lang.magento.urlApi is not set
        magentoImg: remoteUrl + '/media/catalog/product',                   // fetch images from magento
        magentoImgInline: remoteUrl + '/media',                             // fetch inline (e.g. in product description) images from magento
        static: clientUrl,                                                  // load static assets, etc.
        local: remoteUrl + '/rest/V1/snapbasse-konfigurator',               // local api (e.g. load / save cat-trees)
        postBuyRedirect: remoteUrl + '/konfigurator/?cartid={{cartId}}',    // redirect url after you put all items in your cart
        designer: remoteUrl + '/designer',
    },

    category: {
        color: {
            wood: 29,
            shutter: 47,
            pillow: 28
        },
        hide: [
            28,     // color (pillow)
            29,     // color (wood)
            39,     // sisal
            47      // color(shutter)
        ]
    }
};
